module.exports = __webpack_public_path__ + "img/qr_screen.17ee9782.jpg";